// pages/AllUsers.jsx
import React from 'react';
import UserListBase from './UserListBase';

const AllUsers = () => (
    <UserListBase statusFilter="all" title="All Users" subtitle="Every registered device/user, active and inactive" />
);

export default AllUsers;